// extracted by mini-css-extract-plugin
export default {"plan":"plan_plan__uRzmM","planBtn":"plan_planBtn__bEzom"};